/* eslint-disable indent */
import React, { useState, useEffect, useCallback } from "react";
import { Card, Table, DatePicker, Button, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import "./style.scss";
import "../style.scss";

const { Title } = Typography;

const HubWiseView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedDate, setSelectedDate] = useState(moment());
    const [loading, setLoading] = useState(false);
    const [hubWiseData, setHubWiseData] = useState([]);
    const [zone, setZone] = useState("");
    const [reportType, setReportType] = useState("Piece Rate");
    const [reportCategory, setReportCategory] = useState("Business Data");
    const [dataType, setDataType] = useState("today"); // "today" or "range"

    useEffect(() => {
        // Get zone, report category, type, and data type from location state if available
        const zoneValue = location.state?.zone || "";
        const category = location.state?.reportCategory || "Business Data";
        const type = location.state?.reportType || "Piece Rate";
        const typeMode = location.state?.type || "today";
        
        setZone(zoneValue);
        setReportCategory(category);
        setReportType(type);
        setDataType(typeMode);
        
        if (location.state?.date) {
            setSelectedDate(moment(location.state.date));
        }
    }, [location.state]);

    const loadHubWiseData = useCallback(() => {
        if (!zone) return;
        
        setLoading(true);
        
        // TODO: Replace with actual API call based on reportCategory, zone, and dataType
        // API call should be made here with reportCategory, zone, dataType, and selectedDate
        
        // For now, set empty data
        setHubWiseData([]);
        setLoading(false);
    }, [reportCategory, zone, dataType]);

    useEffect(() => {
        // Load data when component mounts or reportCategory/zone/dataType changes
        loadHubWiseData();
    }, [loadHubWiseData]);

    const handleDateSubmit = () => {
        loadHubWiseData();
    };

    const todayDate = selectedDate.format("DD/MM/YYYY");
    const rangeStartDate = selectedDate.startOf("month").format("DD/MM/YYYY");
    const rangeEndDate = selectedDate.format("DD/MM/YYYY");
    const dateRange = `${rangeStartDate} - ${rangeEndDate}`;
    const displayDate = dataType === "today" ? todayDate : dateRange;

    const handleGoBack = () => {
        // Always navigate back to zone-list
        navigate("/zone-list", {
            state: {
                date: selectedDate.format("YYYY-MM-DD"),
                reportType,
                reportCategory,
                type: dataType,
                businessType: location.state?.businessType || "",
            },
        });
    };

    const handleHubClick = (record) => {
        // Don't navigate if it's the Total row
        if (record.hub === "Total") {
            return;
        }
        // Navigate to CP-wise view with hub information
        const routeMap = {
            "Business Data": "/cp-wise-business-data",
            "Shipment Counts": "/cp-wise-shipment-counts",
            "Delivery Data": "/cp-wise-delivery-data",
        };
        navigate(routeMap[reportCategory] || "/cp-wise-business-data", {
            state: {
                zone,
                hub: record.hub,
                reportType,
                reportCategory,
                type: dataType,
                date: selectedDate.format("YYYY-MM-DD"),
            },
        });
    };

    // Hub-wise table columns
    const hubWiseColumns = [
        {
            title: "HUB",
            dataIndex: "hub",
            key: "hub",
            width: "50%",
            render: (text, record) => {
                if (record.hub === "Total") {
                    return <span>{text}</span>;
                }
                return (
                    <span 
                        style={{ 
                            cursor: "pointer", 
                            color: "#1890ff",
                            textDecoration: "none"
                        }}
                    >
                        {text}
                    </span>
                );
            },
        },
        {
            title: "Total",
            dataIndex: "total",
            key: "total",
            width: "50%",
            align: "right",
        },
    ];

    return (
        <div className="director-dashboard hub-wise-page">
            {/* Breadcrumb */}
            <div className="hub-wise-breadcrumb">
                <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    onClick={handleGoBack}
                    className="back-button"
                >
                    Zone List
                </Button>
                <span className="breadcrumb-separator">/</span>
                <span className="breadcrumb-current">Business Statistics Report</span>
            </div>

            {/* Date Filter */}
            <Card className="hub-wise-filter-card">
                <div className="hub-wise-date-filter">
                    <label className="hub-wise-date-label">Date:</label>
                    <DatePicker
                        format="DD/MM/YYYY"
                        value={selectedDate}
                        onChange={(date) => setSelectedDate(date || moment())}
                        className="hub-wise-date-picker"
                    />
                    <Button type="primary" onClick={handleDateSubmit} className="hub-wise-submit-btn">
                        Submit
                    </Button>
                </div>
            </Card>

            {/* Hub Wise Table */}
            <Card className="hub-wise-table-card">
                <Title level={4} className="hub-wise-table-title">
                    HUB Wise {reportCategory} - {displayDate} - {zone} {reportCategory === "Business Data" ? `(${reportType})` : ""}
                </Title>
                <Table
                    columns={hubWiseColumns}
                    dataSource={hubWiseData}
                    pagination={false}
                    loading={loading}
                    size="small"
                    className="hub-wise-table"
                    rowClassName={(record, index) => {
                        if (record.hub === "Total") {
                            return "hub-wise-total-row";
                        }
                        return index % 2 === 0 ? "hub-wise-row-even" : "hub-wise-row-odd";
                    }}
                    onRow={(record) => {
                        return {
                            onClick: () => handleHubClick(record),
                            style: {
                                cursor: record.hub === "Total" ? "default" : "pointer",
                            },
                        };
                    }}
                />
            </Card>
        </div>
    );
};

export default HubWiseView;

